import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_VERSION } from 'src/config';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Open tabs keep running the bundle they loaded. When /version.json reports a newer build,
// reload on the next route change so users pick it up without losing unsaved input.
export default function useVersionCheck() {
  const { pathname } = useLocation();
  const isStale = useRef(false);

  useEffect(() => {
    const check = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        const { version } = await response.json();
        if (version && version !== APP_VERSION) {
          isStale.current = true;
        }
      } catch {
        // Offline, or no version.json (local dev server)
      }
    };
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };

    check();
    const interval = setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (isStale.current) {
      window.location.reload();
    }
  }, [pathname]);
}
